// extracted by mini-css-extract-plugin
export default {"popup":"Popup-module__popup--l5sHt"};